export enum ConnectionType {
  CELLULAR = 'cellular',
  WIFI = 'wifi',
  UNKNOWN = '',
}
